/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc.

  Hardened for buggy themes + mismatched markup.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') attribute = '';
  }
  return jQuery.trim(attribute);
}

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // noop
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + encodeURIComponent(attributeToString(note)),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') callback(cart);
      else ShopifyAPI.onCartUpdate(cart);
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = null;
  try {
    data = JSON.parse(XMLHttpRequest.responseText);
  } catch (e) {
    // fallback
    try { data = eval('(' + XMLHttpRequest.responseText + ')'); } catch (e2) { data = null; }
  }

  if (data && data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  } else {
    // last resort
    console && console.error && console.error('Cart error', textStatus, XMLHttpRequest);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the line item
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') callback(line_item, form);
      else ShopifyAPI.onItemAdded(line_item, form);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') errorCallback(XMLHttpRequest, textStatus);
      else ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function(cart) {
    if ((typeof callback) === 'function') callback(cart);
    else ShopifyAPI.onCartUpdate(cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') callback(cart);
      else ShopifyAPI.onCartUpdate(cart);
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback,
      buildCart, cartCallback, adjustCart, adjustCartCallback, qtySelectors, validateQty;

  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : '.CartCount',
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = settings.cartCostSelector ? $(settings.cartCostSelector) : null;

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Prevent double-binding if init gets called more than once
    $body.off('.lwAjaxCart');

    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector && $cartCountSelector.length) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      if (cart.item_count === 0) $cartCountSelector.addClass('hidden-count');
    }
    if ($cartCostSelector && $cartCostSelector.length) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function () {
    $addToCart.removeClass('is-adding').addClass('is-added');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest) {
    var data = null;
    try { data = JSON.parse(XMLHttpRequest.responseText); }
    catch(e) { try { data = eval('(' + XMLHttpRequest.responseText + ')'); } catch(e2) { data = null; } }

    $addToCart.removeClass('is-adding is-added');

    if (data && data.message && data.status == 422) {
      var $addButtoncontainer = $formContainer.find('.product-add');
      $addButtoncontainer.before('<div class="errors qty-error">'+ data.description +'</div>');
    }
  };

  cartUpdateCallback = function (cart) {
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function(cart) {
    $cartContainer.empty();

    if (cart.item_count === 0) {
      $cartContainer.append(
        '<p class="cart-content"> Your cart is currently empty. <a class="dt-sc-btn" href="/collections/all">Continue Shopping</a></p>'
      );
      cartCallback(cart);
      return;
    }

    var items = [],
        data = {},
        source = $('#CartTemplate').html(),
        template = Handlebars.compile(source);

    $.each(cart.items, function(index, cartItem) {
      var prodImg;

      if (cartItem.image !== null) {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_medium$1')
          .replace('http:', '');
      } else {
        prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      }

      // Clean properties (remove hidden / empty)
      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) delete cartItem.properties[key];
        });
      }

      // Format line-level discounts
      if (cartItem.line_level_discount_allocations && cartItem.line_level_discount_allocations.length) {
        for (var i = 0; i < cartItem.line_level_discount_allocations.length; i++) {
          var amount = cartItem.line_level_discount_allocations[i].amount;
          cartItem.line_level_discount_allocations[i].formattedAmount =
            Shopify.formatMoney(amount, settings.moneyFormat);
        }
      }

      // Format cart-level discounts
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
        for (var j = 0; j < cart.cart_level_discount_applications.length; j++) {
          var cartAmount = cart.cart_level_discount_applications[j].total_allocated_amount;
          cart.cart_level_discount_applications[j].formattedAmount =
            Shopify.formatMoney(cartAmount, settings.moneyFormat);
        }
      }

      items.push({
        key: cartItem.key,
        line: index + 1,
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discountedPrice: Shopify.formatMoney(cartItem.final_line_price, settings.moneyFormat),
        discounts: cartItem.line_level_discount_allocations,
        discountsApplied: (cartItem.line_level_discount_allocations && cartItem.line_level_discount_allocations.length) ? true : false,
        vendor: cartItem.vendor
      });
    });

    data = {
      items: items,
      note: cart.note,
      subTotalPrice: Shopify.formatMoney(cart.items_subtotal_price, settings.moneyFormat),
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      cartTotalDiscounts: Shopify.formatMoney(cart.total_discount, settings.moneyFormat),
      cartDiscounts: cart.cart_level_discount_applications,
      cartDiscountsApplied: (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) ? true : false,
      cartTotalSavings: (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length === 0 && cart.total_discount > 0)
    };

    $cartContainer.append(template(data));
    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate events because cart HTML is replaced

    // Qty +/-
    $body.on('click.lwAjaxCart', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt(($qtySelector.val() || '').replace(/\D/g, ''), 10);

      qty = validateQty(qty);

      if ($el.hasClass('ajaxcart__qty--plus')) qty += 1;
      else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      if (line) updateQuantity(line, qty);
      else $qtySelector.val(qty);
    });

    // Remove button (force qty to 0)
    $body.on('click.lwAjaxCart', '.ajaxcart__qty-remove', function() {
      var $el = $(this),
          line = $el.data('line');

      if (line) updateQuantity(line, 0);
    });

    // Manual qty change
    $body.on('change.lwAjaxCart', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt(($el.val() || '').replace(/\D/g, ''), 10);

      qty = validateQty(qty);
      if (line) updateQuantity(line, qty);
    });

    // Prevent submit while updating
    $body.on('submit.lwAjaxCart', 'form.ajaxcart', function(evt) {
      if (isUpdating) evt.preventDefault();
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // IMPORTANT: scope to cart container so we don't hit random [data-line] elsewhere
      var $scope = $(settings.cartContainer);

      // Your template uses: <div class="ajaxcart row" data-line="X">
      // So: find data-line, then climb to the LI wrapper
      var $hit = $scope.find('[data-line="' + line + '"]').first();

      // Prefer LI.ajaxcart__product, but allow theme variations
      var $row = $hit.closest('.ajaxcart__product');
      if (!$row.length) $row = $hit.closest('li');
      if (!$row.length) $row = $hit; // last resort

      $row.addClass('is-loading');
      if (qty === 0) $row.addClass('is-removed');

      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed (drawer or cart page)
    $body.on('change.lwAjaxCart', 'textarea[name="note"], #DrawerCartNote, #CartSpecialInstructions', function() {
      var newNote =
        $('#DrawerCartNote').val() ||
        $('#CartSpecialInstructions').val() ||
        $('textarea[name="note"]').first().val() ||
        '';

      ShopifyAPI.updateCartNote(newNote, function() {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;
    updateCountPrice(cart);

    // Re-render cart shortly after change
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150);
  };

  qtySelectors = function() {
    // Leave theme behavior in place (optional feature)
    // If your theme replaces number inputs with custom markup, it should happen elsewhere.
  };

  validateQty = function (qty) {
    if ((parseFloat(qty) == parseInt(qty, 10)) && !isNaN(qty)) {
      return qty;
    }
    return 1;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
